import React from 'react';

import { Tooltip as AntdTooltip } from 'antd';
/**
 * @description Tooltip component
 *
 * @author  Rohit Niraj Singh <@rohit.singh3>
 *
 * @reference https://ant.design/components/tooltip
 *
 * @param {import('antd').TooltipProps} props
 *
 * @returns {React.Element}
 */

const Tooltip = (props) => {
	const { children = null, ...restProps } = props;
	return <AntdTooltip {...restProps}>{children}</AntdTooltip>;
};

export default Tooltip;
